import { Fade, IconButton, useTheme } from '@mui/material';
import { VyIcon } from '@weft/icons';
import React from 'react';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';
import { LogoIcon } from '../../../icons/LogoIcon';

type NavbarLogoProps = {
  showFullNav: boolean;
};

export const NavbarLogo: React.FC<NavbarLogoProps> = ({ showFullNav }) => {
  const vyTheme = useTheme();
  const navigate = useVyNavigate();

  return (
    <IconButton
      sx={{
        padding: !showFullNav ? '24px 0 32px 16px' : '24px 0 32px 24px',
        display: 'flex',
        borderRadius: '0px',
        width: 'min-content',
      }}
      onClick={() => navigate('/home')}
    >
      <Fade
        in={showFullNav}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <LogoIcon className="h-[27px] w-[72px]" />
        </div>
      </Fade>

      <Fade
        in={!showFullNav}
        mountOnEnter
        unmountOnExit
      >
        <div className="pb-[27px]">
          <VyIcon
            icon="SmallVayu"
            color={vyTheme.palette.tertiary.main}
            fill={vyTheme.palette.tertiary.main}
            className="absolute left-4 top-6 h-[27px] w-[27px]"
          />
        </div>
      </Fade>
    </IconButton>
  );
};